import type { Path } from "three";

export enum ThreeShapeSideTypes {
	corner = 0,
	side = 1,
	connector = 2,
}

/**
 * @param code - based upon SideName from packages/shapes/src/lib/models/Side/SideName.ts
 */
export interface ThreeSidePathsType {
	path: Path;
	group?: string;
	groupCodes?: string[];
	type: ThreeShapeSideTypes;
	code: string;
}

/**
 * @param code - key of the values from DimensionProperties in workpiece.ts
 */
export interface ThreeInputLinesType {
	dimension: number;
	path: Path;
	type?: ThreeShapeSideTypes;
	doubleOffset?: boolean;
	code: string;
}
